import type { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

export default {
    root: {
        padding: '0',
        background: 'transparent',
        gap: '0.5rem',
        transitionDuration: '{transition.duration}',
    },
    item: {
        color: '{primary.color}',
        hoverColor: '{primary.hoverColor}',
        borderRadius: '{content.border.radius}',
        gap: '{navigation.item.gap}',
        icon: {
            color: '{primary.color}',
            hoverColor: '{primary.hoverColor}',
        },
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: '{focus.ring.shadow}',
        },
    },
    separator: {
        color: '{primary.hoverColor}',
    },
} satisfies BreadcrumbDesignTokens;
